import React from 'react'

export default function GistListSkeleton({ count = 5 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card card-compact bg-base-100">
          <div className="card-body">
            <div className="skeleton h-6 w-3/4 mb-2"></div>
            <div className="flex gap-2">
              <div className="skeleton h-4 w-20"></div>
              <div className="skeleton h-4 w-16"></div>
              <div className="skeleton h-4 w-16"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
